import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {catchError, map, tap} from 'rxjs/operators';
import {of, throwError} from 'rxjs';
import {HttpClient, HttpClientModule, HttpHeaders} from '@angular/common/http';
import {CommonModule, DatePipe} from '@angular/common';
import {UserService} from '@services/user.service';
import {OdooService} from '@services/odoo.service';
import {ApiService, ResponsePost} from '@services/api.service';

import {Response, Request} from '@services/api.service';
import {TruncatePipe} from '../../truncate.pipe';
import {ClickedItem} from '../../app.component';
import {PaginationComponent} from '@components/pagination/pagination.component';
import {SearchPanelComponent} from '@components/search-panel/search-panel.component';


export interface SearchConfig {
  key: string;
  label: string;
  type: 'text' | 'select' | 'date';
  options?: {label: string; value: string}[];
}

@Component({
  selector: 'app-my-requests',
  imports: [CommonModule, HttpClientModule, DatePipe, TruncatePipe, PaginationComponent, SearchPanelComponent],
  templateUrl: './my-requests.component.html',
  styleUrl: './my-requests.component.css'
})

export class MyRequestsComponent implements OnInit {

  @Output() rowClicked = new EventEmitter<ClickedItem>();
  @Output() navigate = new EventEmitter<string>();

  requests: Request[] = []
  pagedData: Request[] = []
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalPages: number = 0;


  searchPanelConfig: SearchConfig[] = [
    {key: 'name', label: 'Nome', type: 'text'},
    {key: 'code', label: 'Codice', type: 'text'},
    {key: 'state', label: 'Stato', type: 'select',
      options: [
        {label: 'Accetata', value: 'accepted'},
        {label:'Rifiutata', value: 'rejected'},
        {label:'In corso', value: 'in_progress'},
        {label:'Integrazione Necessaria', value: 'integration_required'},
        {label:'Chiusa', value: 'closed'}
      ]},
    {key: 'date_from', label: 'Dal', type: 'date'},
    {key: 'date_to', label: 'Al', type: 'date'},
  ]

  currentSort: {
    field: string; direction: 'asc' | 'desc' } = {
    field: 'id',
    direction: 'desc',
  }

  currentFilters: any = {}

  constructor(
    private http: HttpClient,
    public userService: UserService,
    private odooService: OdooService,
    private apiService: ApiService
  ) {
  }

  ngOnInit(): void {
    this.fetchRequests({})
  }

  onRowClicked(id: number) {

    this.apiService.getRequest(id).pipe(
      tap((item) => this.rowClicked.emit({ type: 'request', item: item })),
      catchError(err => {
        return throwError(() => new Error(err))
      })
    ).subscribe();
  }

  fetchRequests(params: any) {

    params = {
      ...params,
      direction: this.currentSort.direction,
      order: this.currentSort.field
    }
    this.apiService.getRequests(this.userService.getUser()?.username, params).pipe(
      map((response: ResponsePost) => {
        if (response.result.status != 'error') {
          return response.result.data;
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero delle richieste", error);
        return of([])
      })
    ).subscribe(
      requests => {
        this.requests = requests;
        this.totalPages = Math.ceil(this.requests.length / this.itemsPerPage);
        this.paginateData();
      }
    )
  }

  onNavigate(page: string) {
    this.navigate.emit(page);
  }

  paginateData() {
    const startIndex = (this.currentPage -1) * this.itemsPerPage;;
    const endIndex = startIndex + this.itemsPerPage;
    this.pagedData = this.requests.slice(startIndex, endIndex);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginateData()
    }
  }

  onSearchParamChange(params: any): void  {
    this.currentFilters = params
    this.fetchRequests(params);
  }

  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.direction = this.currentSort.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.direction = 'asc'
    }
    this.fetchRequests(this.currentFilters)
  }
}
